import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import AgeVerificationWrapper from './components/wrappers/AgeVerificationWrapper';
import { AgeVerificationProvider } from './context/AgeVerificationContext';
import { AtmProvider } from './context/AtmContext';
import { AuthProvider } from './context/AuthContext';
import { initializeGA } from './services/analyticsService';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Initialize Google Analytics
initializeGA();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <AtmProvider>
            <AgeVerificationProvider>
              <AgeVerificationWrapper>
                <App />
              </AgeVerificationWrapper>
            </AgeVerificationProvider>
          </AtmProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
